import { QUERY_KEYS_SIA } from '../../../Common/hooks/useChartsData';

export const subtitlesMap = {
    [QUERY_KEYS_SIA.AGE_GROUP]: [
        {
            type: '00',
            description: 'Idade compatível com o SIGTAP',
            color: '#4CAC54'
        },
        {
            type: '01',
            description: 'Idade EM BRANCO',
            color: '#168CFB'
        },
        {
            type: '02',
            description: 'Idade fora da faixa do SIGTAP',
            color: '#6FB9F8'
        },
        {
            type: '03',
            description: 'Idade inexistente',
            color: '#08DCD4'
        },
        {
            type: '06',
            description: 'Idade não exigida',
            color: '#84C4C4'
        },
        {
            type: '05',
            description: 'Tipo desconhecido',
            color: '#5C5A5F'
        }
    ],
    [QUERY_KEYS_SIA.COMPLEXETY_LEVEL]: [
        {
            type: '00',
            description: 'Tipo desconhecido',
            color: '#4CAC54'
        },
        {
            type: '01',
            description: 'Nível 1',
            color: '#84C4C4'
        },
        {
            type: '02',
            description: 'Nível 2',
            color: '#5C5A5F'
        },
        {
            type: '03',
            description: 'Nível 3',
            color: '#6FB9F8'
        },
        {
            type: '04',
            description: 'Nível 0',
            color: '#08DCD4'
        }
    ],
    [QUERY_KEYS_SIA.GENDER]: [
        {
            type: '00',
            description: '(Em branco)',
            color: '#168CFB'
        },
        {
            type: '01',
            description: 'Feminino',
            color: '#6FB9F8'
        },
        {
            type: '02',
            description: 'Tipo desconhecido',
            color: '#08DCD4'
        },
        {
            type: '03',
            description: 'Masculino',
            color: '#4CAC54'
        }
    ],
    [QUERY_KEYS_SIA.PRODUCTION_SITUATION]: [
        {
            type: '00',
            description: 'Aprovado Parcial',
            color: '#4CAC54'
        },
        {
            type: '01',
            description: 'Aprovado Total',
            color: '#84C4C4'
        },
        {
            type: '02',
            description: 'Não Aprovado',
            color: '#5C5A5F'
        },
        {
            type: '03',
            description: 'Tipo desconhecido',
            color: '#6FB9F8'
        }
    ],
    [QUERY_KEYS_SIA.RACE_COLOR]: [
        {
            type: '00',
            description: 'Tipo desconhecido',
            color: '#168CFB'
        },
        {
            type: '01',
            description: 'Branca',
            color: '#6FB9F8'
        },
        {
            type: '02',
            description: 'Preta',
            color: '#08DCD4'
        },
        {
            type: '03',
            description: 'Parda',
            color: '#4CAC54'
        },
        {
            type: '04',
            description: 'Amarela',
            color: '#84C4C4'
        },
        {
            type: '05',
            description: 'Indígena',
            color: '#5C5A5F'
        },
    ],
    [QUERY_KEYS_SIA.GENERAL_RESULTS]: [
        {
            type: 'bar',
            description: 'Total de Atendimentos',
            color: '#6FB9F8'
        }
    ],
    [QUERY_KEYS_SIA.RACE_COLOR]: [
        {
            type: '00',
            description: 'Tipo desconhecido',
            color: '#168CFB'
        },
        {
            type: '01',
            description: 'Branca',
            color: '#6FB9F8'
        },
        {
            type: '02',
            description: 'Preta',
            color: '#08DCD4'
        },
        {
            type: '03',
            description: 'Parda',
            color: '#4CAC54'
        },
        {
            type: '04',
            description: 'Amarela',
            color: '#84C4C4'
        },
        {
            type: '05',
            description: 'Indígena',
            color: '#5C5A5F'
        },
        {
            type: '99',
            description: 'Sem informação',
            color: '#58D68D'
        }
    ],
    [QUERY_KEYS_SIA.DISCHARGE]: [
        {
            type: '00',
            description: 'Total de Altas',
            color: ['#58D68D', '#5C5A5F']
        }
    ],
    [QUERY_KEYS_SIA.OUTS]: [
        {
            type: '00',
            description: 'Total de Saídas',
            color: ['#6FB9F8', '#08DCD4', '#4CAC54', '#84C4C4']
        }
    ],
    [QUERY_KEYS_SIA.SERVICES]: {
        indicators: [
            {
                type: 'Óbitos',
                color: '#4CAC54'
            },
            {
                type: 'Transferências',
                color: '#168CFB'
            },
            {
                type: 'Altas',
                color: '#6FB9F8'
            },
            {
                type: 'Encerramento',
                color: '#08DCD4'
            },
            {
                type: 'Permanência',
                color: '#84C4C4'
            }
        ]
    },
    [QUERY_KEYS_SIA.PRODUCTION_VALUE]: [
        {
            type: '00',
            description: 'Valor Produzido',
            color: '#084D60'
        },
        {
            type: '01',
            description: 'Valor Aprovado',
            color: '#00A82A'
        }
    ],
    [QUERY_KEYS_SIA.PRODUCTION_QUANTITY]: [
        {
            type: '00',
            description: 'Quantidade Produzida',
            color: '#6FB158'
        },
        {
            type: '01',
            description: 'Quantidade Aprovada',
            color: '#08DCD4'
        }
    ],
    [QUERY_KEYS_SIA.INCREASE_IN_VALUES]: [
        {
            type: '01',
            description: 'Valor Complemento Federal',
            color: '#00A82A'
        },
        {
            type: '02',
            description: 'Valor Complemento Local',
            color: '#6FB158'
        }
    ]
};
